const lang = {
    ja: {
        'adminSettingCustom.customColor': 'カラーテーマ',
        'adminSettingCustom.customName': '項目名称',
        'adminSettingCustom.customComment': 'HOMEコメント',
       
        'adminSettingCustom.customTimerctrl': '各種期間変更',
        
    },
};

export default lang;
